import merge from 'lodash/merge';
import parseClickUrl from './commonParsers/clickUrlParser';
import parseRebate from './commonParsers/rebateParser';

export const parseFlyout = (flyout, state, action) =>
  merge(flyout, {
    merchant: flyout.merchant
      ? {
        clickUrl: parseClickUrl(flyout.merchant.clickUrl, state, action),
        rebate: parseRebate(flyout.merchant.rebate, flyout.merchant.tiers, state),
      }
      : null,
  });

export default (response, state, action) =>
  response.map(category =>
    merge(category, {
      flyout: category.flyout ? parseFlyout(category.flyout, state, action) : null,
    }));
